import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchProduct, fetchProductsPromo } from 'features/hosting/hostingAPI'
import { FREE_DOMAIN_CONFIGS } from 'helpers/helpersSuccessDomain'

const initialState = {
	products: [],
	status: 'idle',
	error: '',
	statusFreeDomain: false,
	noDomain: false,
	freeDomainExtensions: []
}

export const getProducts = createAsyncThunk(
	'products/getFromGID',
	async ({ gid, activePid = null }) => {
		const response = await fetchProduct(gid)
		return { ...response, activePid }
	}
)

export const getHostingByPanel = createAsyncThunk(
	"products/getHostingByPanel",
	async ({ gid, activePid = null }) => {
		const response = await fetchProduct(gid);
		return { ...response, activePid };
	}
);

export const getProductsPromo = createAsyncThunk(
	'products/getFromGIDPromo',
	async (data) => {
		const response = await fetchProductsPromo(data)
		return response
	}
)

const hostingSlice = createSlice({
	name: 'hosting',
	initialState,
	reducers: {
		resetProductsGroup: () => {
			return initialState
		},
		freeDomainHosting: (state, action) => {
			state.statusFreeDomain = action.payload
		},
		isNoDomain: (state, action) => {
			state.noDomain = action.payload
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getProducts.pending, (state) => {
			state.status = 'loading'
			state.products = []
		})
		builder.addCase(getProducts.fulfilled, (state, action) => {
			state.status = 'idle'
			state.products = action.payload.products.product

			if (action.payload.products.product && action.payload.products.product.length > 0) {
				// Cari produk berdasarkan activePid jika ada, jika tidak gunakan yang pertama
				let product;
				if (action.payload.activePid) {
					product = action.payload.products.product.find(p => Number(p.pid) === Number(action.payload.activePid));
				}
				
				// Jika tidak ditemukan berdasarkan PID atau tidak ada activePid, gunakan yang pertama
				if (!product) {
					product = action.payload.products.product[0];
				}
				
				// console.log('Selected product for free domain check:', product);
				const pid = Number(product.pid);

				// Cari config yang cocok
				let foundConfig = null;
				let foundKey = null;
				for (const key in FREE_DOMAIN_CONFIGS) {
					if (FREE_DOMAIN_CONFIGS[key].pids.includes(pid)) {
						foundConfig = FREE_DOMAIN_CONFIGS[key];
						foundKey = key;
						break;
					}
				}
				// console.log('foundConfig:', foundConfig);
				if (foundConfig) {
					state.statusFreeDomain = foundKey;
					state.freeDomainExtensions = foundConfig.extensions;
				} else {
					state.statusFreeDomain = false;
					state.freeDomainExtensions = [];
				}

				// If there's a description with gratis_domain, use it to validate the extensions
				// if (product.description) {
				// 	const descriptionLines = product.description.split('\n');
				// 	const gratisDomainLine = descriptionLines.find(line => line.includes('gratis_domain:'));

				// 	if (gratisDomainLine) {
				// 		const gratisDomainValue = gratisDomainLine.split('gratis_domain:')[1].trim().replace(/"/g, '');

				// 		if (gratisDomainValue) {
				// 			// Clean the value by removing HTML tags and unwanted characters
				// 			const cleanValue = gratisDomainValue
				// 				.replace(/<br\s*\/?>/gi, '') // Remove <br>, <br/>, </br>
				// 				.replace(/<[^>]*>/g, '') // Remove any other HTML tags
				// 				.replace(/\s+/g, ' ') // Normalize whitespace
				// 				.trim();

				// 			const domainExtensions = cleanValue.split('/').map(ext => ext.trim()).filter(ext => ext.length > 0);
				// 			// DEBUG LOGS
				// 			console.log('PID:', pid);
				// 			console.log('FREE_DOMAIN_CONFIGS:', FREE_DOMAIN_CONFIGS);
				// 			console.log('cleanValue:', cleanValue);
				// 			console.log('domainExtensions:', domainExtensions);
				// 			console.log('state.freeDomainExtensions:', state.freeDomainExtensions);
				// 		}
				// 	}
				// }
			}

			state.error = ''
		})
		builder.addCase(getProducts.rejected, (state, action) => {
			state.status = 'idle'
			state.products = []
			state.error = action.error.message
		})
		builder.addCase(getProductsPromo.pending, (state) => {
			state.status = 'loading'
			state.products = []
		})
		builder.addCase(getProductsPromo.fulfilled, (state, action) => {
			state.status = 'idle'
			if (action.payload.products) {
				state.products = action.payload.products.product
			}
			state.error = ''
		})
		builder.addCase(getProductsPromo.rejected, (state, action) => {
			state.status = 'idle'
			state.products = []
			state.error = action.error.message
		})
	},
})
export const { resetProductsGroup, freeDomainHosting, isNoDomain } = hostingSlice.actions
export default hostingSlice.reducer
